import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import { PER_PAGE, formatDate, matchesFilters } from './dashboardUtils';

const DashboardWidgetTable = ({ title, description, dataUrl, emptyMessage, filters, onClose }) => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [failed, setFailed] = useState(false);
    const [page, setPage] = useState(0);

    useEffect(() => {
        let isMounted = true;

        axios
            .get(dataUrl)
            .then((response) => {
                if (isMounted) {
                    setRows(response.data.rows || []);
                }
            })
            .catch(() => {
                if (isMounted) {
                    setFailed(true);
                }
            })
            .finally(() => {
                if (isMounted) {
                    setLoading(false);
                }
            });

        return () => {
            isMounted = false;
        };
    }, [dataUrl]);

    useEffect(() => {
        setPage(0);
    }, [filters.customerId, filters.jobTypeId]);

    const filteredRows = rows.filter((row) => matchesFilters(row, filters));
    const pageCount = Math.max(1, Math.ceil(filteredRows.length / PER_PAGE));
    const visibleRows = filteredRows.slice(page * PER_PAGE, page * PER_PAGE + PER_PAGE);

    return (
        <div className="col-12 mb-4">
            <div className="card shadow-sm">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h6 className="mb-0">{title}</h6>
                    <button type="button" className="btn btn-sm btn-outline-cw-primary" title="Hide details" onClick={onClose}>
                        <i className="fas fa-compress"></i>
                    </button>
                </div>
                <div className="card-body">
                    {description && <p className="text-muted small mb-2">{description}</p>}

                    {loading && <p className="text-muted mb-0"><i className="fas fa-circle-notch fa-spin mr-2"></i>Loading&hellip;</p>}
                    {!loading && failed && <p className="text-danger mb-0"><i className="fas fa-exclamation-triangle mr-2"></i>Failed to load</p>}

                    {!loading && !failed && (
                        <>
                            <div className="table-responsive" style={{ maxHeight: '50vh', overflowY: 'auto' }}>
                                <table className="table table-sm table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th>Job #</th>
                                            <th>Address</th>
                                            <th>Co-ordinator</th>
                                            <th>Customer</th>
                                            <th>Job type</th>
                                            <th>Date ready</th>
                                            <th>Visits</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {visibleRows.map((job) => (
                                            <tr key={job.id}>
                                                <td><a href={job.url}>{job.id}</a></td>
                                                <td>{job.address}</td>
                                                <td>{job.coordinator || '-'}</td>
                                                <td>{job.customer || '-'}</td>
                                                <td>{job.job_type || '-'}</td>
                                                <td>{formatDate(job.date_ready)}</td>
                                                <td>{job.visits}</td>
                                            </tr>
                                        ))}

                                        {!visibleRows.length && (
                                            <tr>
                                                <td colSpan="7" className="text-center">{emptyMessage}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {filteredRows.length > PER_PAGE && (
                                <ReactPaginate
                                    previousLabel={'previous'}
                                    nextLabel={'next'}
                                    breakLabel={'...'}
                                    breakClassName={'break-me'}
                                    pageCount={pageCount}
                                    forcePage={page}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={3}
                                    onPageChange={({ selected }) => setPage(selected)}
                                    containerClassName={'pagination pagination-sm mt-2 mb-0'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                />
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DashboardWidgetTable;
